import { Component, OnInit } from '@angular/core';
import { PuiAuthService } from '../../../core/index';

@Component({
  selector: 'pui-basic',
  templateUrl: 'basic.component.html'
})
export class PuiBasicComponent implements OnInit {
  constructor(private authService: PuiAuthService) { }

  ngOnInit() { }
}
